import { utils as gleamerUtils } from '@gleamer/ui';

/**
 * Pre-annotations (their panel, their toolbar button) belong to the bac mode,
 * where `/local-bac` reads the AI team's JSON, and only once a JSON was read.
 * Other modes never show them, even after a drop in the bac mode: no
 * predictions panel and no predictions API call outside a task.
 */
export function shouldShowPreAnnotations({
  modeName,
  preAnnotationsRead,
}: {
  /** The current mode's route name, as `utils.getMode()` reads it from the URL. */
  modeName: string | null;
  preAnnotationsRead: boolean;
}): boolean {
  return preAnnotationsRead && modeName === gleamerUtils.BAC_MODE_NAME;
}
